var _path, _path2, _circle, _circle2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileUsers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 3.5H15.25C16.4926 3.5 17.5 4.50736 17.5 5.75V18.25C17.5 19.4926 16.4926 20.5 15.25 20.5H8.75C7.50736 20.5 6.5 19.4926 6.5 18.25V5.75C6.5 4.50736 7.50736 3.5 8.75 3.5Z",
    stroke: "currentColor",
    strokeWidth: 1.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.75H14",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 17.1,
    r: 1.05,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10.35,
    r: 1.55,
    stroke: "currentColor",
    strokeWidth: 1.45
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95 14.1C10.45 13.28 11.16 12.85 12 12.85C12.84 12.85 13.55 13.28 14.05 14.1",
    stroke: "currentColor",
    strokeWidth: 1.45,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileUsers);
export default __webpack_public_path__ + "static/media/mobile-users.ee9e498bc0408a47e5922340b6e6726d.svg";
export { ForwardRef as ReactComponent };